export default __webpack_public_path__ + "static/media/faq_bg.fb91387d.jpg";